import { createFileRoute } from "@tanstack/react-router";
import { Material, MaterialService } from "../../api/generated";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { set } from "date-fns";

export const Route = createFileRoute("/material/")({
  component: RouteComponent,
});

type MaterialState =
  | { status: "PENDING" }
  | { material: Material[]; status: "READY" }
  | { error: Error; status: "ERROR" };

function RouteComponent() {
  const [state, setState] = useState<MaterialState>({ status: "PENDING" });

  const [currentMaterial, setCurrentMaterial] = useState<Material | null>(null);

  useEffect(() => {
    loadMaterial();
  }, []);

  async function loadMaterial() {
    setState({ status: "PENDING" });
    try {
      const material = await MaterialService.getMaterials();
      setState({ material, status: "READY" });
    } catch (error) {
      setState({ error: error as Error, status: "ERROR" });
    }
  }

  async function handleFormSubmit(e: FormData) {
    const naam = e.get("naam");
    const omschrijving = e.get("omschrijving");
    if (!naam) {
      return;
    }
    try {
      await MaterialService.postMaterial({
        id: currentMaterial?.id ?? undefined,
        name: naam.toString(),
      });
      loadMaterial();
    } catch (error) {
      setState({ error: error as Error, status: "ERROR" });
    }
    setCurrentMaterial(null);
  }

  async function handleDelete(
    event: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
    material: Material,
  ) {
    event.stopPropagation();
    console.log(material.id);
    await MaterialService.deleteMaterial(material.id!);
    loadMaterial();
  }

  return (
    <div className="flex justify-center items-center">
      <div className="flex w-3/4 justify-center">
        <div className="flex-[3] p-4">
          <div className="overflow-x-auto">
            <table className="table">
              <thead>
                <tr>
                  <th>Naam</th>
                  <th>Omschrijving</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {state.status === "PENDING" && (
                  <tr>
                    <td colSpan={3} className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {state.status === "ERROR" && (
                  <tr>
                    <td colSpan={3} className="text-center">
                      Error: {state.error.message}
                    </td>
                  </tr>
                )}
                {state.status === "READY" &&
                  state.material.map((material) => (
                    <tr
                      key={material.id}
                      onClick={() => setCurrentMaterial(material)}
                      className="hover:bg-base-300 cursor-pointer"
                    >
                      <td>{material.name}</td>
                      {/* <td>{material.description}</td> */}
                      <th>
                        <button
                          className="btn btn-error btn-xs"
                          onClick={(event) => handleDelete(event, material)}
                        >
                          <FontAwesomeIcon icon={faTrashCan} />
                        </button>
                      </th>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex-[1] p-4">
          <button
            className="btn btn-primary"
            onClick={() => setCurrentMaterial(null)}
          >
            Nieuw materiaal
          </button>
          <form action={handleFormSubmit}>
            <fieldset className="fieldset bg-base-200 border border-base-300 p-4 rounded-box">
              <legend className="fieldset-legend">Materiaal</legend>

              <label className="fieldset-label">Naam</label>
              <input
                name="naam"
                type="text"
                className="input"
                placeholder="Naam"
                defaultValue={currentMaterial?.name ?? ""}
              />

              <label className="fieldset-label">Omschrijving</label>
              {/* <input
                name="omschrijving"
                type="text"
                className="input"
                placeholder="Omschrijving"
                defaultValue={currentMaterial?.description ?? ""}
              /> */}

              <button className="btn btn-neutral mt-4">Opslaan</button>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
}
